import { LOCAL, ROOT_FLAG } from "@/store/mutations";
import tracker from "@/store/game/coverage-tracker.store";

const { SET_COVERAGE_STATE_DATA } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: 0,
		title: "",
		description: "",
		sublimits: [],
		isSublimit: false,
		parent: false,
	}),
	modules: {
		deductible: tracker,
		limit: tracker,
	},
	getters: {
		parent: ({ type, parent }, g, rootState) => (parent ? rootState.game.plans[type][parent] : {}),
		useParent: (state, getters) => state.isSublimt && state.limit.toPay > getters.parent.limit.toPay,
		limit: (state, getters) => (getters.useParent ? getters.parent.limit : state.limit),
		deductible: (state, getters) => (state.useParent ? getters.parent.deductible : state.deductible),
		invoiceId: (state, getters) => (state.parent ? getters.parent.id : state.id),
		labels: (state, getters) => ({
			...(state.parent ? getters.parent.labels : state.labels),
		}),
		messages: (state, getters) => ({
			...(state.parent ? getters.parent.messages : state.messages),
		}),
		insured: (state, getters) => ({
			id: getters.invoiceId,
			title: state.isSublimit ? getters.parent.title : state.title,
			toPay: getters.limit.toPay,
			message: getters["limit/willMeet"] ? getters.messages.will_meet_limit : false,
		}),
		"uninsured/deductible": (state, getters) => ({
			id: getters.invoiceId,
			label: getters.labels.deductible,
			toPay: getters.deductible.toPay,
			message: getters["deductible/willMeet"] ? getters.messages.will_meet_deductible : false,
		}),
		"uninsured/overage": (state, getters) => ({
			id: getters.invoiceId,
			label: getters.labels.limit_overage,
			toPay: getters.limit.overage,
			message: getters["limit/met"] ? getters.messages.met_limit : false,
		}),
		"uninsured/coverageGap": (state, getters) => ({
			id: getters.invoiceId,
			label: `${((1 - getters.limit.coveragePercent) * 100).toFixed(0)}% Coverage Gap`,
			toPay: getters.limit.coverageGap,
		}),
	},
	actions: {
		create({ commit }, coverage) {
			commit(SET_COVERAGE_STATE_DATA, coverage);
		},
		calculate({ dispatch, state, getters }, damage) {
			let { cost } = damage;

			if (state.isSublimt) {
				dispatch(`game/plans/${state.type}/${state.parent}/calculate`, { cost }, ROOT_FLAG);
				cost = getters.parent.deductible.overage;
			}

			dispatch("deductible/calculate", { cost });
			cost = state.deductible.overage;

			dispatch("limit/calculate", { cost });
		},
		pay({ dispatch, state, getters }) {
			const insured = getters.limit.toPay;
			const uninsured = getters.deductible.toPay + getters.limit.overage + getters.limit.coverageGap;

			if (state.isSublimt) {
				dispatch(`game/plans/${state.type}/${state.parent}/track`, { amount: insured }, ROOT_FLAG);
			}

			dispatch("deductible/track");
			dispatch("limit/track", { amount: insured });
			dispatch("game/balance/withdraw", { amount: uninsured }, ROOT_FLAG);
		},
	},
	mutations: {
		[SET_COVERAGE_STATE_DATA](state, coverage) {
			Object.entries(coverage).forEach(([key, value]) => {
				if (key === "deductible" || key === "limit") {
					state[key].amount = value;
				} else if (key === "coverage_percent") {
					state.limit.coveragePercent = value;
				} else {
					state[key] = value;
				}
			});
		},
	},
};
